import { connect } from 'react-redux';

import {
  setViewTypePreferenceToList,
  setViewTypePreferenceToShelf,
} from '../actions/catalogue';

import FopViewTypeSwitch from '../components/FopViewTypeSwitch';

export default connect(
  state => ({
    fopViewPreference: state.user.fopViewPreference,
  }),
  {
    setViewTypePreferenceToList,
    setViewTypePreferenceToShelf,
  }
)(FopViewTypeSwitch);
